<template>
  <div style="height:100%;">
    <layout-login>
      <h1>{{ $t('message["638"]') }}</h1>
      <cube-form
        :model="model"
        :options="options"
        @validate="validateHandler"
        @submit.prevent="submitHandler"
      >
        <cube-form-item :field="fields[0]" />
        <cube-form-item :field="fields[1]" />
        <cube-form-item :field="fields[2]" />
        <cube-form-group>
          <cube-button
            type="submit"
            :primary="true"
          >
            {{ $t('message["1052"]') }}
          </cube-button>
        </cube-form-group>
      </cube-form>
      <!-- <p class="reg-login-btn">
        <router-link :to="{name: 'AccountLogin'}">
          已有帐号，直接登录
        </router-link>
      </p> -->
    </layout-login>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import LayoutLogin from '@/components/mobile/account/LayoutLogin'
import { setAuth } from '@/lib/storage'
export default {
  components: {
    LayoutLogin
  },
  data () {
    return {
      options: {
        scrollToInvalidField: true,
        layout: 'classic' // classic fresh
      },
      validity: {},
      valid: undefined,
      model: {
        username: '',
        password: '',
        truename: ''
      },
      inviteLogin: {
        mobile: this.$route.query.mobile,
        ensecret: this.$route.query.ensecret
      },
      fields: [
        {
          type: 'input',
          modelKey: 'username',
          label: '',
          props: {
            placeholder: this.$t('message["1015"]')
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'password',
          label: '',
          props: {
            placeholder: this.$t('message["1028"]'),
            type: 'password'
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'truename',
          label: '',
          props: {
            placeholder: this.$t('message["1029"]')
          },
          rules: {
            required: true
          }
        }
      ]
    }
  },
  computed: {
    ...mapState('account/register', ['submitting', 'decorators'])
  },
  methods: {
    ...mapActions('account/register', ['ajaxRegSecond']),
    async submitHandler (e) {
      const obj = Object.assign(this.model, this.inviteLogin)
      const chain = await this.ajaxRegSecond()
      chain.params(obj)
        .onSuccess(raw => {
          setAuth(raw.Authorization)
          this.$store.commit('setAuth', raw.Authorization, { root: true })
          this.$router.push({ name: 'AccountInfo' })
        })
        .onNetSuccess((res) => {
          // console.log(res.data.message)
          // console.log(res)
          const toast = this.$createToast({
            time: 2000,
            txt: res.data.message || res.data.payload[0].message,
            type: 'txt'
          })
          toast.show()
        })
        .setForm(this.form)
        .fetch()
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    }
  }
}
</script>
<style lang="scss" scoped>
  .reg-login-btn {
    text-align: center;
    line-height: 46px;
    margin-top: 20px;
  }
</style>
